module.exports = __webpack_public_path__ + "static/media/qr_code.edd2e4fe.svg";